<template lang="pug">
  div(v-if="currentDocument")
    t-key-value-data(
      v-for="(row, idx) in rows"
      :key="idx"
      :item="row"
    )
</template>

<script>
import { mapGetters } from 'vuex'
import TKeyValueData from '~/components/templates/t-key-value-data'

export default {
  name: 'BlockDocumentGeneralInfo',
  components: {
    TKeyValueData
  },
  props: {
    documentId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('admindocuments', {
      items: 'items'
    }),
    currentDocument() {
      return this._.find(this.items, item => item.id === this.documentId)
    },
    rows() {
      return [
        {
          key: this.$t('Name'),
          value: this.currentDocument.title
        },
        {
          key: this.$t('Document state'),
          value: this.$t(this._.upperFirst(this.currentDocument.state))
        },
        {
          key: this.$t('Date of creation'),
          value: this.$moment.parseZone(this.currentDocument.createdAt).format('DD.MM.YYYY HH:mm')
        },
        {
          key: this.$t('File ext'),
          value: this.currentDocument.fileExtension
        },
        {
          key: this.$t('Signature type'),
          value: this.$t(this.currentDocument.signatureType)
        },
        {
          key: this.$t('Archived document'),
          value: this.handleBooleanYesOrNo(this.currentDocument.archived)
        },
        {
          key: this.$t('Templated document'),
          value: this.handleBooleanYesOrNo(this.currentDocument.template)
        },
        {
          key: this.$t('Cancellation act'),
          value: this.handleBooleanYesOrNo(this.currentDocument.cancellationAct)
        },
        {
          key: this.$t('Public document'),
          value: this.handleBooleanYesOrNo(this.currentDocument.hasPublicAccess)
        },
        {
          key: this.$t('Refused document'),
          value: this.handleBooleanYesOrNo(this.currentDocument.refused)
        },
        {
          key: this.$t('Tags'),
          value: this._.map(this.currentDocument.tags, tag => tag.name).join(', ')
        }
      ]
    }
  },
  created() {
    this.fetchDocument()
  },
  methods: {
    async fetchDocument() {
      try {
        await this.$store.dispatch('admindocuments/read', { id: this.documentId })
      } catch (e) {
        this.$handlers.error(e, this)
      }
    },
    handleBooleanYesOrNo(value) {
      return value ? this.$t('Yes') : this.$t('No')
    }
  }
}
</script>

<style scoped lang="scss"></style>
